module.exports = __webpack_public_path__ + "img/tips_02.d12d2c57.png";